// src/app/core/services/admin/product-stock.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductStockService {
  private host = environment.operHost;

  constructor(private http: HttpClient) {}

  createStock(data: any): Observable<any> {
    const url = `${this.host}/api/v1/product_stock`;
    return this.http.post(url, data);
  }

  getProducts(): Observable<any> {
    const url = `${this.host}/api/v1/product`;
    return this.http.get<any>(url);
  }

  /**
   * Busca estoque com opção de limitar a quantidade de itens retornados.
   * @param limit número máximo de itens a retornar (opcional; default undefined)
   */
  getStock(limit?: number): Observable<any> {
    let url = `${this.host}/api/v1/product_stock`;
    if (limit && Number(limit) > 0) {
      url += `?limit=${limit}`;
    }
    return this.http.get<any>(url);
  }

  exportStock(): Observable<Blob> {
    const url = `${this.host}/api/v1/product_stock/export`;
    return this.http.get(url, { responseType: 'blob' });
  }

  /**
   * Remove lote já adicionado ao estoque
   * @param batchId
   * @returns
   */
  deleteBatch(batchId: number): Observable<any> {
    return this.http.delete(`${this.host}/api/v1/product_batch/${batchId}`);
  }
}
